export function splitFilmTitle(filmTitle: string) {
  let filmTag = ""
  if (filmTitle?.match(/\s\|\s/) && filmTitle.match(/opening night|closing night|event|talk|free/i)) {
    const [first, ...rest] = filmTitle.split(/\s\|\s/)
    filmTag = first
    filmTitle = rest.join(" | ")
  }

  return { filmTitle, filmTag }
}
